import React from "react";

interface PillProps {
  active?: boolean;
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

export function Pill({ active, children, style = {}, className = "", onClick, disabled }: PillProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`
        ${active ? "pill-active" : "pill"}
        ${disabled ? "cursor-not-allowed opacity-40" : ""}
        ${className}
      `}
      style={style}
    >
      {children}
    </button>
  );
}
